export const ACTION_LOGIN = 'LOGIN';

export const setCurrentUser = (data) => ({
    type: ACTION_LOGIN,
    payload: data
});